import axios from 'axios'
// import config from '../config'

export default {
  request (method, uri, data = null) {
    if (!method) {
      console.error('API function call requires method argument')
      return
    }
    if (!uri) {
      console.error('API function call requires uri argument')
      return
    }

    const url = '../' + uri + ((data == null) ? ('?' + Math.random()) : '')
    return axios({ method, url, data })
  }
}
